import {
  ChangeDetectionStrategy,
  Component,
  InputSignal,
  OutputEmitterRef,
  Signal,
  WritableSignal,
  computed,
  input,
  output,
  signal,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

import {
  IndustryCatalog,
  IndustryCatalogOpenTasks,
  UpdateIndustryCatalog,
} from '@mp/content-manager/industriekataloge/data-access';
import { CatalogCardComponent } from '@mp/shared/ui';
import { PlatformSupplierBasic } from '@mpsm/shared/domain';
import { CatalogSupplierSelectorComponent } from '@mpsm/shared/ui';

@Component({
  selector: 'mpcm-industry-catalog-card',
  templateUrl: './industry-catalog-card.component.html',
  styleUrl: './industry-catalog-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CatalogSupplierSelectorComponent, CatalogCardComponent, MatButton, MatIcon],
})
export class IndustryCatalogCardComponent {
  readonly catalog: InputSignal<IndustryCatalog> = input.required<IndustryCatalog>();

  readonly canWrite: InputSignal<boolean> = input.required<boolean>();

  readonly platformSuppliers: InputSignal<PlatformSupplierBasic[]> = input<PlatformSupplierBasic[]>([]);
  readonly isLoadingPlatformSuppliers: InputSignal<boolean> = input<boolean>(false);

  readonly supplierSearchTermChanges: OutputEmitterRef<string> = output<string>();

  readonly catalogDetailsClick: OutputEmitterRef<string> = output<string>();

  readonly saveClick: OutputEmitterRef<UpdateIndustryCatalog> = output<UpdateIndustryCatalog>();

  protected readonly assignedSupplier: WritableSignal<PlatformSupplierBasic | undefined> = signal<
    PlatformSupplierBasic | undefined
  >(undefined);

  protected readonly isEditMode: Signal<boolean> = computed(
    () => this.catalog().status === 'NotAssigned' && this.canWrite(),
  );

  protected readonly isCatalogSaveDisabled: Signal<boolean> = computed(
    () => !this.isEditMode() || !this.assignedSupplier(),
  );

  protected readonly openTaskIconMap: Record<keyof IndustryCatalogOpenTasks, string> = {
    supplierAssignment: 'local_shipping',
    packagingUnitsAssignment: 'straighten',
    manufacturerAssignment: 'factory',
  };

  changeSupplier(supplier: PlatformSupplierBasic | undefined): void {
    this.assignedSupplier.set(supplier);
  }

  saveSupplier(supplierId?: string): void {
    const id: string | undefined = supplierId || this.assignedSupplier()?.supplierId;

    if (id) {
      this.saveClick.emit({ supplierId: id });
    }
  }
}
